import { requestBase } from "@/plugins/axios";
// {username,password}
export function factoryLogin(data) {
  return requestBase(
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      url: "v1/login",
      method: "POST",
      data: data,
    },
    true
  );
}
// {username,password}
export function platformLogin(data) {
  return requestBase(
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      url: "v1/login",
      method: "POST",
      data: data,
    },
    true
  );
}


